import { useEffect, useState } from 'react';
import workspaceAPI from '../../services/workspaceAPI';

const WorkspaceBookings = () => {
  const [bookings, setBookings] = useState([]);
  const [canManage, setCanManage] = useState(false);
  const [error, setError] = useState('');

  const load = () => {
    workspaceAPI
      .getBookings()
      .then((res) => {
        setBookings(res.data.bookings || []);
        setCanManage(res.data.canManage);
      })
      .catch((err) => setError(err.response?.data?.message || 'Failed to load bookings'));
  };

  useEffect(() => { load(); }, []);

  const updateStatus = (id, status) => {
    workspaceAPI.updateBookingStatus(id, status).then(load).catch((err) => setError(err.response?.data?.message || 'Update failed'));
  };

  if (error) return <p className="workspace-alert error">{error}</p>;

  return (
    <div>
      <h1 className="workspace-page-title">Booking management</h1>
      <p className="workspace-page-subtitle">View and manage company bookings. Admins can approve or decline.</p>
      <div className="workspace-table-wrap">
        <table className="workspace-table">
          <thead>
            <tr><th>Guest</th><th>Property</th><th>Type</th><th>Status</th><th>Date</th>{canManage && <th>Actions</th>}</tr>
          </thead>
          <tbody>
            {bookings.map((b) => (
              <tr key={b._id}>
                <td>{b.user?.name || b.user?.email}</td>
                <td>{b.property?.name || '—'}</td>
                <td>{b.bookingType}</td>
                <td>{b.status}</td>
                <td>{new Date(b.createdAt).toLocaleDateString()}</td>
                {canManage && (
                  <td>
                    {b.status === 'pending' && (
                      <>
                        <button type="button" className="workspace-btn secondary" onClick={() => updateStatus(b._id, 'approved')}>Approve</button>{' '}
                        <button type="button" className="workspace-btn secondary" onClick={() => updateStatus(b._id, 'declined')}>Decline</button>
                      </>
                    )}
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default WorkspaceBookings;
